import Vue from "vue";
import VueRouter from "vue-router";
import routes from "./routes";
import store from "../store";
import VueMeta from "vue-meta";

Vue.use(VueRouter);
Vue.use(VueMeta);

// configure router
const router = new VueRouter({
  mode: "history",
  routes, // short for routes: routes
  linkActiveClass: "active",
  scrollBehavior: (to, from, savedPosition) => {
    if (savedPosition) {
      return savedPosition;
    }
    if (to.hash) {
      return { selector: to.hash };
    }
    return { x: 0, y: 0 };
  },
});

// Creates a `nextMiddleware()` function which not only
// runs the default `next()` callback but also triggers
// the subsequent Middleware function.
function nextFactory(context, middleware, index) {
  const subsequentMiddleware = middleware[index];
  // If no subsequent Middleware exists,
  // the default `next()` callback is returned.
  if (!subsequentMiddleware) return context.next;

  return (...parameters) => {
    // Run the default Vue Router `next()` callback first.
    context.next(...parameters);
    // Then run the subsequent Middleware with a new
    // `nextMiddleware()` callback.
    const nextMiddleware = nextFactory(context, middleware, index + 1);
    subsequentMiddleware({ ...context, next: nextMiddleware });
  };
}

router.beforeEach((to, from, next) => {
  if (store.getters["appConfig/appConfig"] == null) {
    store.dispatch("appConfig/get");
  }

  const globalOrganization = store.getters["organizations/globalOrganization"];
  const queryParams = {
    ...to.query,
    ...(globalOrganization ? { org_id: globalOrganization.id } : {}),
  };
  if (JSON.stringify(to.query) !== JSON.stringify(queryParams)) {
    router.replace({ ...to, query: queryParams });
  }

  if (to.meta.middleware) {
    const middleware = Array.isArray(to.meta.middleware)
      ? to.meta.middleware
      : [to.meta.middleware];
    const context = { from, next, to, router };
    const nextMiddleware = nextFactory(context, middleware, 1);

    return middleware[0]({ ...context, next: nextMiddleware });
  }

  return next();
});

router.afterEach((to, from, failure) => {
  if (!failure) {
    const documentClasses = document.body.classList;
    documentClasses.remove("modal-open");
  }
});

export default router;
